export const fixRefName = (refName?: string): string => {
  if (!refName) return "";

  // Branch format: refs/heads/branch-name
  const branchMatch = refName.match(/^refs\/heads\/(.+)$/);
  if (branchMatch) {
    return branchMatch[1]!;
  }

  // PR format: refs/pull/123/merge
  const prMatch = refName.match(/^refs\/pull\/(\d+)\/merge$/);
  if (prMatch) {
    return `pr-${prMatch[1]}`;
  }

  // PR short ref (e.g. GITHUB_REF_NAME on pull_request): "1913/merge"
  const prShortMatch = refName.match(/^(\d+)\/merge$/);
  if (prShortMatch) {
    return `pr-${prShortMatch[1]}`;
  }

  // Tag format: refs/tags/tag-name
  const tagMatch = refName.match(/^refs\/tags\/(.+)$/);
  if (tagMatch) {
    return tagMatch[1]!;
  }

  // Yarn / workspace release ref: "user-dashboard@0.274.0" or "@scope/pkg@1.0.0"
  const workspaceMatch = refName.match(/^(?:@[^/]+\/[^@]+|[^@/]+)@(.+)$/);
  if (workspaceMatch) {
    return workspaceMatch[1]!;
  }

  return "";
};

/**
 * Same value for Sentry browser `release` and `@sentry/vite-plugin` `release.name`
 * (must match so uploaded source maps apply to runtime events).
 */
export function sentryReleaseName(
  shortRefName?: string,
  fullRef?: string,
  sha?: string,
): string {
  return fixRefName(shortRefName) || fixRefName(fullRef) || (sha?.trim() ?? "");
}
